/* eslint-disable camelcase */
import _ from 'lodash';
import { GetRegion } from 'constants.js';

export const getApaValdiations = ({ mobile_phone_provider_configuration }) => {
  try {
    const config = JSON.parse(mobile_phone_provider_configuration);
    return _.get(config, [GetRegion()]) || _.get(config, ['default']);
  } catch (err) {
    return {};
  }
};
